module.exports = {
          srcSet: "/_next/static/images/img-immobilier@2x-200-38e807eb117a645e7d7fb47a0b6ef990.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-immobilier@2x-200-38e807eb117a645e7d7fb47a0b6ef990.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-immobilier@2x-200-38e807eb117a645e7d7fb47a0b6ef990.jpg",
          toString:function(){return "/_next/static/images/img-immobilier@2x-200-38e807eb117a645e7d7fb47a0b6ef990.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }